import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    messageToast, 
    objectShowNumber, 
    status200,
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    doiTuongValue,
    objectDoiTuong,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../../../utils/define';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import HoSoLuuTruModal from './HoSoLuuTruModal';

const DotTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [namTuyenSinh, setNamTuyenSinh] = useState(new Date().getFullYear());

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModalLuuTru, setOpenModalLuuTru] = useState(false);
    const [dotTuyenSinhLuuTruId, setDotTuyenSinhLuuTruId] = useState('');
    const [dotTuyenSinhLuuTruName, setDotTuyenSinhLuuTruName] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('nam') != null && parseInt(paramUrl.get('nam'), 10) !== namTuyenSinh) {
        setNamTuyenSinh(parseInt(paramUrl.get('nam'), 10));
    }

    const replaceHistory = (Page, Size, Search, Nam) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DOTTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['dotTuyenSinhData', valueSearch, page, pageSize, namTuyenSinh],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamTuyenSinh: namTuyenSinh
            };
            replaceHistory(page, pageSize, valueSearch, namTuyenSinh);
            return Get(DOTTUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    const { data: listNamData } = useQuery(
        ['listNamTuyenSinh'],
        () => Get(DOTTUYENSINH_API.GET_LIST_NAM, null, null),
        { keepPreviousData: true }
    );
    const rawListNam = (Array.isArray(listNamData) ? listNamData : listNamData?.$values) || [];
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namTuyenSinh)) {
            const maxYear = Math.max(...rawListNam);
            setNamTuyenSinh(maxYear);
            replaceHistory(1, pageSize, search, maxYear);
        }
    }, [listNamData, namTuyenSinh]);

    useEffect(() => {
        refetch();
    }, [pageSize, page, namTuyenSinh]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namTuyenSinh);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namTuyenSinh);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namTuyenSinh);
    };

    const onChangeNamTuyenSinh = (e) => {
        const nam = Number(e.target.value);
        setNamTuyenSinh(nam);
        setPage(1);
        replaceHistory(1, pageSize, search, nam);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(DOTTUYENSINH_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const handleOpenModalLuuTru = (id, name) => {
        setDotTuyenSinhLuuTruId(id);
        setDotTuyenSinhLuuTruName(name);
        setOpenModalLuuTru(true);
    };

    const handleCloseModalLuuTru = () => {
        setOpenModalLuuTru(false);
        setDotTuyenSinhLuuTruId('');
        setDotTuyenSinhLuuTruName('');
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.DOTTUYENSINH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOLIENTUC_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namTuyenSinh} onChange={onChangeNamTuyenSinh} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                            <NavLink to={URI_INTERNAL.DOTTUYENSINH_CREATE_PATH} className="btn btn-success ml-3">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tên đợt</th>
                                    <th className="text-center">Năm TS</th>
                                    <th>Loại tuyển sinh</th>
                                    <th>Đối tượng</th>
                                    <th>Chỉ tiêu</th>
                                    <th>Lệ phí</th>
                                    <th>Trạng thái</th>
                                    <th>Thời gian nhận</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={10}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={10}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={10}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.tenDot || item.TenDot}</td>
                                            <td className="text-center">{item.namTuyenSinh || item.NamTuyenSinh}</td>
                                            <td>{getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</td>
                                            <td>{getLabelFromEnum(item.doiTuong ?? item.DoiTuong, objectDoiTuong, doiTuongValue)}</td>
                                            <td>
                                                {(() => {
                                                    const valDoiTuong = item.doiTuong ?? item.DoiTuong;
                                                    const actualDoiTuong = typeof valDoiTuong === 'string' ? doiTuongValue[valDoiTuong] : valDoiTuong;
                                                    const quan = item.chiTieuQuan ?? item.ChiTieuQuan ?? 0;
                                                    const dan = item.chiTieuDan ?? item.ChiTieuDan ?? 0;
                                                    if (actualDoiTuong === doiTuongValue.quan) return quan;
                                                    if (actualDoiTuong === doiTuongValue.khac) return dan;
                                                    if (actualDoiTuong === doiTuongValue.quanVaDan) return (
                                                        <>
                                                            Quân: {quan} <br />
                                                            Dân: {dan}
                                                        </>
                                                    );
                                                    return 0;
                                                })()}
                                            </td>
                                            <td>{new Intl.NumberFormat('vi-VN').format(item.lePhi ?? item.LePhi ?? 0)}</td>
                                            <td>{getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</td>
                                            <td>
                                                {(item.ngayNhanHoSo || item.NgayNhanHoSo) && moment(item.ngayNhanHoSo || item.NgayNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)} 
                                                {' - '}
                                                {(item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo) && moment(item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)}
                                            </td>
                                            <td>
                                                <Button
                                                    variant="info"
                                                    size="sm"
                                                    className="mr-2"
                                                    onClick={() => handleOpenModalLuuTru(item.id, item.tenDot || item.TenDot)}>
                                                    Lưu trữ
                                                </Button>
                                                <NavLink
                                                    className="btn btn-primary btn-sm mr-2"
                                                    to={`${URI_INTERNAL.DOTTUYENSINH_EDIT_PATH}?id=${item.id}`}>
                                                    Sửa
                                                </NavLink>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => deleteAction(item.id, item.tenDot || item.TenDot)}>
                                                    Xóa
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />

                    <HoSoLuuTruModal
                        isOpen={openModalLuuTru}
                        onClose={handleCloseModalLuuTru}
                        dotTuyenSinhId={dotTuyenSinhLuuTruId}
                        tenDot={dotTuyenSinhLuuTruName}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default DotTuyenSinh;
